module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTkiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA1OSA2MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3QgeD0iMC41IiB5PSIwLjU3MzI0MiIgd2lkdGg9IjU4IiBoZWlnaHQ9IjU4IiByeD0iMjkiIHN0cm9rZT0id2hpdGUiLz4KPHBhdGggZD0iTTIwIDE1LjA3MzJWNDUuMDczMkw0MyAzMC4wNzMyTDIwIDE1LjA3MzJaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fanclub/notes/play.svg
// module id = y7MK
// module chunks = 7